import { fExecuteAPI } from "../../Server/Apis";
import {
  Truck_Attribute_GETROW,
  Truck_Load_GETROW,
  Truck_Save_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast, 
  fcheck_null_undefine_replace_empty, 
} from "../../Utility/Utilitys";
 

import { vRdxUserInfo,   TruckRo } from "../../Redux/roStore";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = LoadingReceipt();
 
export const ErrorMsg = {
  TruckCode:"",
    TrackingID:"",
    DriverName:"",
    TruckName:"",
    PurchaseDate:"",
    OnService:"",
    OnLease:"",
    Sold:"",
    WMS:"",
    Length:"",
    Width:"",
    Height:"",
    CBM:"",
};

export const GridDataColumnsWmsSiDetail_Def = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "TruckCode", width: 100 },
  { field: "Brand", headerName: "TrackingID", width: 100 },
  { field: "DriverName", headerName: "DriverName", width: 100 },
  { field: "Name1", headerName: "TruckName", width: 100 },
  { field: "PurchaseDt", headerName: "PurchaseDate", width: 100 , valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY")},
  { field: "Service", headerName: "OnService", width: 100 },
  { field: "Lease", headerName: "OnLease", width: 100 },
  { field: "Sold", headerName: "Sold", width: 100 },
  { field: "WMS", headerName: "WMS", width: 100 },
  { field: "Length", headerName: "Length", width: 100 },
  { field: "Width", headerName: "Width", width: 100 },
  { field: "Height", headerName: "Height", width: 100 },
  { field: "CBM", headerName: "CBM", width: 100 },
];
     
const fKeyLoadingReceipt = (event) => { 
  const form = document.getElementById("TruckHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyLoadingReceiptContent = (event) => { 
  const form = document.getElementById("TruckContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (vRdxHead.TruckCode === "" || vRdxHead.TruckCode === null || vRdxHead.TruckCode === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      TruckCode: "TruckCode should not be empty",
    }));
    fAlertToast("FAILED", "TruckCode should not be empty");
    iRes = false;
  }

  if (vRdxHead.TrackingID === "" || vRdxHead.TrackingID === null || vRdxHead.TrackingID === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      TrackingID: "TrackingID should not be empty",
    }));
    fAlertToast("FAILED", "TrackingID should not be empty");
    iRes = false;
  }

  if (vRdxHead.DriverName === "" || vRdxHead.DriverName === null || vRdxHead.DriverName === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      DriverName: "DriverName should not be empty",
    }));
    fAlertToast("FAILED", "DriverName should not be empty");
    iRes = false;
  }

  if (vRdxHead.TruckName === "" || vRdxHead.TruckName === null || vRdxHead.TruckName === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      TruckName: "TruckName should not be empty",
    }));
    fAlertToast("FAILED", "TruckName should not be empty");
    iRes = false;
  }

  if (vRdxHead.PurchaseDate === "" || vRdxHead.PurchaseDate === null || vRdxHead.PurchaseDate === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      PurchaseDate: "Enter valid date",
    }));
    fAlertToast("FAILED", "Enter valid date");
    iRes = false;
  }

  let iDate = moment(vRdxHead.PurchaseDate).format("MM/DD/YYYY");
  if (vRdxHead.PurchaseDate == "Invalid Date" || new Date(iDate) < new Date("01/01/1990")) {
    setErrorMsg((obj) => ({
      ...obj,
      PurchaseDate: "Date is invalid",
    }));
    fAlertToast("FAILED", "Date is invalid");
    iRes = false;
  }

  if (vRdxHead.Length === "" || vRdxHead.Length === null || vRdxHead.Length === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      Length: "Length should not be empty",
    }));
    fAlertToast("FAILED", "Length should not be empty");
    iRes = false;
  } else if (vRdxHead.Length == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Length: "Length should not be zero",
    }));
    fAlertToast("FAILED", "Length should not be zero");
    iRes = false;
  }

  if (vRdxHead.Width === "" || vRdxHead.Width === null || vRdxHead.Width === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      Width: "Width should not be empty",
    }));
    fAlertToast("FAILED", "Width should not be empty");
    iRes = false;
  } else if (vRdxHead.Width == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Width: "Width should not be zero",
    }));
    fAlertToast("FAILED", "Width should not be zero");
    iRes = false;
  }

  if (vRdxHead.Height === "" || vRdxHead.Height === null || vRdxHead.Height === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      Height: "Height should not be empty",
    }));
    fAlertToast("FAILED", "Height should not be empty");
    iRes = false;
  } else if (vRdxHead.Height == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      Height: "Height should not be zero",
    }));
    fAlertToast("FAILED", "Height should not be zero");
    iRes = false;
  }

  if (vRdxHead.CBM === "" || vRdxHead.CBM === null || vRdxHead.CBM === undefined) {
    setErrorMsg((obj) => ({
      ...obj,
      CBM: "CBM should not be empty",
    }));
    fAlertToast("FAILED", "CBM should not be empty");
    iRes = false;
  } else if (vRdxHead.CBM == 0) {
    setErrorMsg((obj) => ({
      ...obj,
      CBM: "CBM should not be zero",
    }));
    fAlertToast("FAILED", "CBM should not be zero");
    iRes = false;
  }

  return iRes;
};

const fLoad_Grid = async (setDetailGridData) => { 
  let iSIDetailObj = {
    v_Typ: "A",
    v_Data: "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);
  const iSIDetailResult = await Truck_Load_GETROW(FinalObj);
  if (iSIDetailResult?.status == 200) {
    if (iSIDetailResult.data.ResultSet.length > 0) {
     
      let GridID = iSIDetailResult.data.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setDetailGridData(GridID);
    } else {
      setDetailGridData([]);
    }
  }
 
};

//HEAD LOADING API
// Api

 

 

 
 

//API SaveSIHead
const fSaveHead = async (fNewDetail) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = TruckRo();
  let vSaveSIHeadObj = {
    v_UId: HeadObject.TruckCode,
    v_Name1: HeadObject.TruckName,
    v_Brand: HeadObject.TrackingID,
    v_PurchaseDt: HeadObject.PurchaseDate,
    v_Driver: HeadObject.DriverName,
    v_Service: HeadObject.OnService,
    v_Lease: HeadObject.OnLease,
    v_Sold: HeadObject.Sold,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_Length: HeadObject.Length,
    v_Width: HeadObject.Width,
    v_Height: HeadObject.Height,
    v_CBM: HeadObject.CBM,
    v_WMS: HeadObject.WMS,
    
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await Truck_Save_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    // eslint-disable-next-line eqeqeq

    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};

 
 

export const GetAttributes = async (setAttribute) => {
  // const vRdxUserInfoObj = vRdxUserInfo();
  // var vObj = {
  //   userCode: vRdxUserInfoObj.UserID,
  //   userGroupCode: vRdxUserInfoObj.UserGroupCode,
  // };
  const iAttributes = await Truck_Attribute_GETROW({});
  if (iAttributes?.status === 200) {
    setAttribute(iAttributes?.data?.ResultSet);

    return iAttributes?.data?.ResultSet;
  } else {
    setAttribute({
      DriverName: [],
    });
    return [];
  }
};
 
export {
  // rows,
  // columns,
  fKeyLoadingReceipt,
  fKeyLoadingReceiptContent,  
  //save
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,  
};
